"use strict";

exports.__esModule = true;
exports.ContextMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconButton = require("../../Clickables/IconButton/IconButton");
var _Icon = require("../../Elements/Icon/Icon");
var _ThemeProvider = require("../../ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable import/prefer-default-export */
/* eslint react/forbid-prop-types: 0 */

function setTog(arr, index, isMultipleSelect) {
  if (!isMultipleSelect && !arr[index].isToggle) {
    arr == null || arr.forEach((item, i) => {
      if (item.isToggle) {
        arr[i].isToggle = false;
      }
    });
  }
  arr[index].isToggle = !arr[index].isToggle;
  return arr;
}
const ContextMenu = props => {
  const {
    icon,
    items,
    cssModifier,
    isMultipleSelect,
    active,
    id,
    isOpen,
    isIconTail,
    setOpenMenu,
    openMenu,
    setIsOpen,
    bsPrefix,
    isRtl,
    size,
    variant,
    iconArgs,
    onChange,
    isTargetInComposedPath
  } = props;
  const prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'content-menu');
  const options = items;
  const cssModi = cssModifier || 'table-header';
  const [open, setOpen] = (0, _react.useState)(isOpen);
  const [toggle, setToggle] = (0, _react.useState)(items);
  const ref = (0, _react.useRef)();

  // When a menu is opened, set isOpen to true
  // (this keeps track of whether any menu is currently open)
  // allowing other menus to be opened just by hovering
  (0, _react.useEffect)(() => {
    if (open) {
      setIsOpen(true);
      setOpenMenu(id);
    }
  }, [open]);

  // If a menu becomes open, close any other open menus
  (0, _react.useEffect)(() => {
    if (openMenu !== id) {
      setOpen(false);
    }
  }, [openMenu]);

  // When a menu becomes active, close any open menus
  (0, _react.useEffect)(() => {
    setOpenMenu(undefined);
  }, [active]);
  (0, _react.useEffect)(() => {
    const listener = event => {
      // use target from composedPath when isTargetInComposedPath is truthy
      const [target] = isTargetInComposedPath && event.composedPath ? event.composedPath() : [event.target];
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(target)) {
        return;
      }
      setOpen(false);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  });
  const isRTL = (0, _ThemeProvider.useIsRTL)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    dir: isRTL || isRtl ? 'rtl' : 'ltr',
    className: "ccl-e-custom-dropdown ccl-e-custom-dropdown--content-menu-dropdown",
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `ccl-e-custom-dropdown__container ccl-e-custom-dropdown__container--${cssModi} ccl-e-custom-dropdown__container--${cssModi}-open-${open} `,
      children: [(icon || iconArgs) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
        ...iconArgs,
        size: iconArgs ? iconArgs.size : size,
        icon: icon || (iconArgs == null ? void 0 : iconArgs.icon),
        variant: variant || (iconArgs == null ? void 0 : iconArgs.variant),
        active: open,
        handleClick: e => {
          e.preventDefault();
          onChange(e);
          setOpen(!open);
        },
        handleOnChange: e => {
          onChange(e);
        }
      }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: `ccl-e-custom-dropdown__container__list-items ccl-e-custom-dropdown__container__list-items--${cssModi}`,
        children: options == null ? void 0 : options.map((Item, index) => {
          const optionProps = options[index];
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: `ccl-e-custom-dropdown__container__list-items__item 
                  ccl-e-custom-dropdown__container__list-items__item--${cssModi} 
                  ccl-e-custom-dropdown__container__list-items__item--${cssModi}--${!isMultipleSelect && optionProps.isToggle ? 'active' : 'default'}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: `ccl-e-custom-dropdown__container__list-items__item__button ccl-e-custom-dropdown__container__list-items__item__button--${cssModi}  ccl-e-custom-dropdown__container__list-items__item__button--${optionProps.isDisabled ? "disabled" : ''}  ccl-e-custom-dropdown__container__list-items__item__button--${size}`,
              onClick: () => {
                if (optionProps.hasOwnProperty("isToggle")) {
                  setTog(options, index, isMultipleSelect);
                  setToggle(options);
                }
                optionProps.onclick();
                setOpen(!open);
              },
              children: [optionProps.hasOwnProperty("isToggle") && (!!optionProps.isToggle ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: `${prefix}-icon-label ${prefix}-icon-label--notTail} `,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  className: `${prefix}__icon`,
                  type: "check",
                  size: "xs"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: `${prefix}__icon__text`,
                  children: optionProps.text
                })]
              }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: `${prefix}-icon-label`,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  className: `${prefix}__icon`,
                  color: "",
                  size: "xs",
                  type: "empty-space"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: `${prefix}__icon__text`,
                  children: optionProps.text
                })]
              })), !optionProps.hasOwnProperty("isToggle") && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: `${prefix}-icon-label  ${prefix}-icon-label--${!isIconTail ? 'notTail' : 'tail'} `,
                children: [!isIconTail && optionProps.hasOwnProperty('icon') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  className: `${prefix}__icon`,
                  type: Item.icon || 'empty-space',
                  size: "xs"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: `${prefix}__icon__text`,
                  children: optionProps.text
                }), isIconTail && optionProps.hasOwnProperty('icon') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                  className: `${prefix}__icon`,
                  type: Item.icon || 'empty-space',
                  size: "xs"
                })]
              })]
            })
          }, index);
        })
      })]
    })
  });
};
exports.ContextMenu = ContextMenu;
ContextMenu.defaultProps = {
  setActiveMenu: () => {},
  isOpen: false,
  isIconTail: false,
  setOpenMenu: () => {},
  setIsOpen: () => {},
  onChange: () => {},
  // (selectedId, item) => {},
  size: 'large',
  variant: 'plain',
  isTargetInComposedPath: false
};